<template>
    <b-modal
        id="modal-create-download-file"
        ref="modal-create-download-file"
        centered
        ok-title="Aceptar"
        ok-variant="primary"
        cancel-title="Cancelar"
        title="Agregar Nuevo Archivo Descargable"
        :ok-disabled="disableOkButton"
        @ok="onUpload"
        @hidden="resetForm()"
    >
        <b-form id="download-file-upload-form" @submit.stop.prevent="onSubmit()">
            <b-form-group
                id="input-group-download-file-name"
                label="*Nombre:"
                label-for="input-download-file-name"
            >
                <b-form-input
                    id="input-download-file-name"
                    v-model.trim="$v.form.name.$model"
                    name="name"
                    type="text"
                    required
                    placeholder="Nombre a mostrar"
                    :state="validateState('name')"
                    :disabled="formDisabled"
                />
                <b-form-invalid-feedback id="input-download-file-name-feedback">
                    <ul>
                        <li v-if="!$v.form.name.required">Este campo es requerido.</li>
                    </ul>
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                id="input-group-download-file-type"
                label="*Tipo de Descarga:"
                label-for="input-download-file-type"
            >
                <b-form-select
                    id="input-download-file-type"
                    name="downloadType"
                    v-model="form.downloadType"
                    :disabled="formDisabled"
                    :options="downloadTypesAvailable"
                />
            </b-form-group>
            <hr />
            <b-form-group
                id="input-group-download-file"
                label="*Archivo:"
                label-for="input-download-file"
                label-size="lg"
                description="Solo se permite un (1) archivo, en caso de entregar más archivos, por favor comprímalos en formato .zip o .rar"
            >
                <b-form-file
                    id="input-download-file"
                    v-model="$v.form.file.$model"
                    size="lg"
                    placeholder="Escoja o arrastre un archivo aquí..."
                    drop-placeholder="Arrastre archivo aquí..."
                    browse-text="Buscar"
                    :state="validateState('file')"
                    :disabled="formDisabled"
                    :file-name-formatter="formatNames"
                />
                <b-form-invalid-feedback id="input-download-file-feedback">
                    <ul>
                        <li v-if="!$v.form.file.required">Un archivo es requerido.</li>
                        <li v-if="!$v.form.file.justOneFile">Solo se permite subir un único archivo.</li>
                    </ul>
                </b-form-invalid-feedback>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'DownloadFileCreateFormModal',
    data () {
        return {
            downloadTypesAvailable: [
                'Entregas',
                'Exámenes',
                'Guías',
                'Laboratorio',
                'Proyectos',
                'Taller',
                'Teoría',
                'Práctica',
                'Otro'
            ],
            formDisabled: false,
            form: {
                name: '',
                file: null,
                downloadType: 'Entregas'
            }
        }
    },
    validations: {
        form: {
            name: {
                required
            },
            file: {
                required,
                justOneFile: function (val) {
                    if (val === null) return true
                    return val instanceof File
                }
            }
        }
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getActiveSiteIdentifiers'
        ]),
        disableOkButton () {
            return this.formDisabled || this.$v.form.$invalid
        }
    },
    methods: {
        ...mapActions([
            'readCourseSiteByAcademicPeriod',
            'createSiteDownloadFile'
        ]),
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        formatNames (files) {
            if (files.length === 1) {
                return files[0].name
            } else {
                return `${files.length} archivos seleccionados`
            }
        },
        async onUpload (bvModalEvt) {
            bvModalEvt.preventDefault() // Prevent modal from closing
            await this.onSubmit() // Trigger submit handler
        },
        resetForm () {
            this.form.file = null
            this.form.name = ''
            this.form.downloadType = 'Entregas'
            this.$v.$reset()
        },
        async onSubmit () {
            let loader = null
            try {
                loader = this.$root.$loading.show()
                this.formDisabled = true
                const payloadData = { ...this.form, courseSiteId: this.activeSite.id }
                await this.createSiteDownloadFile(payloadData)
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-create-download-file')
                })
                this.resetForm()
                // Reload the current active site data
                await this.readCourseSiteByAcademicPeriod({
                    courseCode: this.getActiveSiteIdentifiers.courseCode,
                    academicPeriod: this.getActiveSiteIdentifiers.academicPeriod
                })
                this.$root.successToast(`Archivo descargable creado exitosamente.`)
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    }
}
</script>
